/**
 * @flow
 * @relayHash df5db71d9812e40c8dee6793f25ec127
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobList_jobEdges$ref = any;
export type JobSortField = "CREATED_AT" | "CUSTOMER" | "JOB_NUMBER" | "PROMISED_AT" | "STATUS" | "UPDATED_AT";
export type JobStateStatus = "COMPLETE" | "INCOMPLETE" | "IN_PROGRESS" | "NEEDS_ATTENTION" | "PAUSED";
export type RunStatus = "COMPLETE" | "IN_PROGRESS" | "PAUSED" | "SCHEDULED";
export type SortDirection = "ASC" | "DESC";
export type WorkflowStateType = "JOB_COMPLETED" | "JOB_CREATED" | "JOB_ITEM_COUNT" | "RUN" | "TASK";
export type JobSort = {|
  field: JobSortField,
  direction: SortDirection,
|};
export type JobListPanelQueryVariables = {|
  search?: ?string,
  sortBy?: ?JobSort,
  jobNumbers?: ?$ReadOnlyArray<string>,
  customerIds?: ?$ReadOnlyArray<string>,
  name?: ?string,
  userIds?: ?$ReadOnlyArray<string>,
  workflowIds?: ?$ReadOnlyArray<string>,
  itemName?: ?string,
  itemPartNumber?: ?string,
|};
export type JobListPanelQueryResponse = {|
  +jobs: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +states: $ReadOnlyArray<{|
          +id: string,
          +workflowState: {|
            +id: string,
            +name: string,
            +machineType: ?{|
              +id: string,
              +name: string,
            |},
            +type: ?WorkflowStateType,
          |},
          +runs: $ReadOnlyArray<{|
            +id: string,
            +createdAt: any,
            +status: RunStatus,
          |}>,
          +isEnabled: boolean,
          +status: JobStateStatus,
        |}>,
        +workflow: {|
          +id: string,
          +states: $ReadOnlyArray<{|
            +id: string,
            +name: string,
            +isRequired: ?boolean,
            +type: ?WorkflowStateType,
          |}>,
          +transitions: $ReadOnlyArray<{|
            +id: string,
            +toWorkflowState: {|
              +id: string
            |},
            +fromWorkflowState: {|
              +id: string
            |},
          |}>,
        |},
      |},
      +$fragmentRefs: JobList_jobEdges$ref,
    |}>
  |}
|};
export type JobListPanelQuery = {|
  variables: JobListPanelQueryVariables,
  response: JobListPanelQueryResponse,
|};
*/


/*
query JobListPanelQuery(
  $search: String
  $sortBy: JobSort
  $jobNumbers: [String!]
  $customerIds: [ID!]
  $name: String
  $userIds: [ID!]
  $workflowIds: [ID!]
  $itemName: String
  $itemPartNumber: String
) {
  jobs(sortBy: $sortBy, statuses: [OPEN], first: 100, search: $search, jobNumbers: $jobNumbers, customerIds: $customerIds, name: $name, userIds: $userIds, workflowIds: $workflowIds, itemName: $itemName, itemPartNumber: $itemPartNumber) {
    edges {
      node {
        id
        states {
          id
          workflowState {
            id
            name
            machineType {
              id
              name
            }
            type
          }
          runs {
            id
            createdAt
            status
          }
          isEnabled
          status
        }
        workflow {
          id
          states {
            id
            name
            isRequired
            type
          }
          transitions {
            id
            toWorkflowState {
              id
            }
            fromWorkflowState {
              id
            }
          }
        }
      }
      ...JobList_jobEdges
    }
  }
}

fragment JobList_jobEdges on JobEdge {
  node {
    id
    states {
      id
      isEnabled
      workflowState {
        id
        name
        machineType {
          id
          name
        }
      }
      runs {
        id
        createdAt
        status
      }
    }
    workflow {
      id
      isParallelWorkflow
    }
    ...DraggableJobCard_job
    ...AddUpdateRunModal_job
    ...AutoScheduleJobModal_job
  }
}

fragment DraggableJobCard_job on Job {
  id
  jobNumber
  name
  ...RunList_job
  workflow {
    id
    states {
      id
      name
      isRequired
      type
    }
    transitions {
      id
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
    }
    isParallelWorkflow
  }
  states {
    id
    isEnabled
    status
    workflowState {
      id
      name
      type
    }
    runs {
      id
      createdAt
      status
    }
  }
  order {
    id
    promisedAt
  }
}

fragment AddUpdateRunModal_job on Job {
  id
  states {
    id
    isEnabled
    workflowState {
      id
      name
      machineType {
        id
      }
    }
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AutoScheduleJobModal_job on Job {
  id
  workflow {
    id
    states {
      id
      type
      name
    }
    transitions {
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
      id
    }
  }
  states {
    id
    isEnabled
    workflowState {
      id
      name
      type
      machineType {
        id
      }
    }
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment RunList_job on Job {
  id
  workflow {
    id
    states {
      id
      name
      isRequired
      type
    }
    transitions {
      id
      toWorkflowState {
        id
      }
      fromWorkflowState {
        id
      }
    }
  }
  states {
    id
    isEnabled
    status
    workflowState {
      id
      name
      type
    }
    runs {
      id
      scheduledStartAt
      status
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "JobSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "jobNumbers",
    "type": "[String!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "name",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "workflowIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemName",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemPartNumber",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "customerIds",
    "variableName": "customerIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Variable",
    "name": "itemName",
    "variableName": "itemName"
  },
  {
    "kind": "Variable",
    "name": "itemPartNumber",
    "variableName": "itemPartNumber"
  },
  {
    "kind": "Variable",
    "name": "jobNumbers",
    "variableName": "jobNumbers"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  },
  {
    "kind": "Literal",
    "name": "statuses",
    "value": [
      "OPEN"
    ]
  },
  {
    "kind": "Variable",
    "name": "userIds",
    "variableName": "userIds"
  },
  {
    "kind": "Variable",
    "name": "workflowIds",
    "variableName": "workflowIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "workflowState",
  "storageKey": null,
  "args": null,
  "concreteType": "WorkflowState",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "machineType",
      "storageKey": null,
      "args": null,
      "concreteType": "MachineType",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    (v5/*: any*/)
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isEnabled",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "states",
  "storageKey": null,
  "args": null,
  "concreteType": "WorkflowState",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isRequired",
      "args": null,
      "storageKey": null
    },
    (v5/*: any*/)
  ]
},
v11 = [
  (v2/*: any*/)
],
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "transitions",
  "storageKey": null,
  "args": null,
  "concreteType": "WorkflowTransition",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "toWorkflowState",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkflowState",
      "plural": false,
      "selections": (v11/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "fromWorkflowState",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkflowState",
      "plural": false,
      "selections": (v11/*: any*/)
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "JobListPanelQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "jobs",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "JobConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "runs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Run",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ]
                      },
                      (v9/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflow",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workflow",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v10/*: any*/),
                      (v12/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "JobList_jobEdges",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "JobListPanelQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "jobs",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "JobConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "runs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Run",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "scheduledStartAt",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      (v9/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflow",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workflow",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v10/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isParallelWorkflow",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "jobNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "promisedAt",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYieldConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYield",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": (v4/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "__typename",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "cursor",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "endCursor",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasNextPage",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "yields",
                    "args": null,
                    "handle": "connection",
                    "key": "AddUpdateRunModal_job_yields",
                    "filters": []
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "yields",
                    "args": null,
                    "handle": "connection",
                    "key": "AutoScheduleJobModal_job_yields",
                    "filters": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "JobListPanelQuery",
    "id": null,
    "text": "query JobListPanelQuery(\n  $search: String\n  $sortBy: JobSort\n  $jobNumbers: [String!]\n  $customerIds: [ID!]\n  $name: String\n  $userIds: [ID!]\n  $workflowIds: [ID!]\n  $itemName: String\n  $itemPartNumber: String\n) {\n  jobs(sortBy: $sortBy, statuses: [OPEN], first: 100, search: $search, jobNumbers: $jobNumbers, customerIds: $customerIds, name: $name, userIds: $userIds, workflowIds: $workflowIds, itemName: $itemName, itemPartNumber: $itemPartNumber) {\n    edges {\n      node {\n        id\n        states {\n          id\n          workflowState {\n            id\n            name\n            machineType {\n              id\n              name\n            }\n            type\n          }\n          runs {\n            id\n            createdAt\n            status\n          }\n          isEnabled\n          status\n        }\n        workflow {\n          id\n          states {\n            id\n            name\n            isRequired\n            type\n          }\n          transitions {\n            id\n            toWorkflowState {\n              id\n            }\n            fromWorkflowState {\n              id\n            }\n          }\n        }\n      }\n      ...JobList_jobEdges\n    }\n  }\n}\n\nfragment JobList_jobEdges on JobEdge {\n  node {\n    id\n    states {\n      id\n      isEnabled\n      workflowState {\n        id\n        name\n        machineType {\n          id\n          name\n        }\n      }\n      runs {\n        id\n        createdAt\n        status\n      }\n    }\n    workflow {\n      id\n      isParallelWorkflow\n    }\n    ...DraggableJobCard_job\n    ...AddUpdateRunModal_job\n    ...AutoScheduleJobModal_job\n  }\n}\n\nfragment DraggableJobCard_job on Job {\n  id\n  jobNumber\n  name\n  ...RunList_job\n  workflow {\n    id\n    states {\n      id\n      name\n      isRequired\n      type\n    }\n    transitions {\n      id\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n    }\n    isParallelWorkflow\n  }\n  states {\n    id\n    isEnabled\n    status\n    workflowState {\n      id\n      name\n      type\n    }\n    runs {\n      id\n      createdAt\n      status\n    }\n  }\n  order {\n    id\n    promisedAt\n  }\n}\n\nfragment AddUpdateRunModal_job on Job {\n  id\n  states {\n    id\n    isEnabled\n    workflowState {\n      id\n      name\n      machineType {\n        id\n      }\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AutoScheduleJobModal_job on Job {\n  id\n  workflow {\n    id\n    states {\n      id\n      type\n      name\n    }\n    transitions {\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n      id\n    }\n  }\n  states {\n    id\n    isEnabled\n    workflowState {\n      id\n      name\n      type\n      machineType {\n        id\n      }\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RunList_job on Job {\n  id\n  workflow {\n    id\n    states {\n      id\n      name\n      isRequired\n      type\n    }\n    transitions {\n      id\n      toWorkflowState {\n        id\n      }\n      fromWorkflowState {\n        id\n      }\n    }\n  }\n  states {\n    id\n    isEnabled\n    status\n    workflowState {\n      id\n      name\n      type\n    }\n    runs {\n      id\n      scheduledStartAt\n      status\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bf558a68f76a36c6962e2e2451b3ce0a';
module.exports = node;
